import styled from '@emotion/styled';
import { TextResult } from '@gameonly/core';
import Markdown from '../../ui/Markdown';
import { DARK_BLUE, GREEN } from '../colors';
import EcoGuideImg from '../images/eco-guide.png';
import { useTranslation } from 'react-i18next';
import keyify from '../../project/parameters/keyify';

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
  width: 100%;
`;

const ActionBlock = styled.div`
  width: 100%;
  background: ${DARK_BLUE};
  color: #fff;
  padding: 2rem 1.5rem 1rem 1.5rem;
  clip-path: polygon(40px 0, 100% 0, 100% 100%, 0 100%, 0 40px);
  font-size: 1rem;
  font-family: Causten, sans-serif !important;
  text-align: justify;

  ul {
    list-style-type: ' \u203A ';
    list-style-position: inside;
    line-height: 1;
    text-align: left;
    padding-left: 0 !important;
  }

  li p {
    display: inline;  // This prevents <p> from breaking to a new line under the marker
    margin: 0;        // Removes default spacing
    text-align: justify;
  }

  li::marker {
    display: inline-block;
    margin-right: 0.5rem;
    margin-left: -0.5rem;
    font-size: 1.2rem;
  }
`;

const EcoGuideBlock = styled.div`
  width: 100%;
  background: ${GREEN};
  display: flex;
  align-items: stretch;
  padding: 0;
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - 40px),
    calc(100% - 40px) 100%,
    0 100%
  );
  overflow: hidden;
`;

const EcoGuideImageContainer = styled.div`
  width: 40%;
  height: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  background: #fff;
  border: 3px solid black;
`;

const EcoGuideImage = styled.img`
  object-fit: cover;
  max-height: 150px;
  border-radius: 0;
  display: block;
`;

const EcoGuideText = styled.div`
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  font-family: Causten, sans-serif;
  text-align: left;
  align-items: center;
  padding: 0 2.5rem;
  width: 60%;
  display: flex;
  align-items: center;
`;

export const ActionsPage = ({ modelName, result }: { modelName: string, result: TextResult }) => {
  const { t } = useTranslation();
  const translationPrefix = `model:${keyify(modelName)}`;
  const textResultTranslationPrefix = `${translationPrefix}.result.${result.code?.toLowerCase()}`;

  const textContent = t(`${textResultTranslationPrefix}.text`);
  const ecoGuideText = t('project:pdf.actionsPage.ecoGuideText')
  return (
    <Main>
      {textContent && (
        <ActionBlock>
          <Markdown>{textContent}</Markdown>
        </ActionBlock>
      )}
      <EcoGuideBlock>
        <EcoGuideImageContainer>
          <EcoGuideImage src={EcoGuideImg} alt="" />
        </EcoGuideImageContainer>
        <EcoGuideText>
          <Markdown>{`› ${ecoGuideText}`}</Markdown>
        </EcoGuideText>
      </EcoGuideBlock>
    </Main>
  );
};
